import { React, useState } from "react";
import { Layout, Row, Col, Form, Input, Button, message } from "antd";
import {
  FullHeightRow,
  AuthLeftContainer,
  HaberForm,
  AuthTitleBlock,
} from "../styledElements";
import AuthRightContainer from "../../Components/AuthRightBox/authRightContainer";
import { Link } from "react-router-dom";
import { usePasswordValidation } from "../../hooks/usePasswordValidation";
import AlertContainer from "../../Components/AlertBoxes/alertBox";
import Logo from "../../Assets/Images/logo.svg";
import correctIcon from "../../Assets/Icons/correct.svg";
import wrongIcon from "../../Assets/Icons/wrong.svg";
import { useLocation } from "react-router-dom";
import { confirmForgotPassword } from "../../Services/forgotPasswordServices";
import alertGreen from '../../Assets/Icons/alertGreen.svg';


const validateMessages = {
  required: "This field is required!",
  types: {
    email: "Email is not a valid email!",
  },
};
const changePasswordMessage = {
  success:
    "Your password is successfully changed.Now you can go to login page and use new password to login.",
  error: "",
};

const ChangePassword = (props) => {
  const location = useLocation();
  const [userEmail, setUserEmail] = useState(location.state.userEmail);
  const [changePasswordStatus, setChangePasswordStatus] = useState(false);

  const [password, setPassword] = useState({
    firstPassword: "",
    secondPassword: "",
  });

  const [validLength, hasNumber, upperCase, lowerCase, match, specialChar] =
    usePasswordValidation({
      firstPassword: password.firstPassword,
      secondPassword: password.secondPassword,
    });

  const setFirst = (event) => {
    setPassword({ ...password, firstPassword: event.target.value });
  };
  const setSecond = (event) => {
    setPassword({ ...password, secondPassword: event.target.value });
  };
  const onFinish = async (values) => {
    let verificationCode = location.state.code;
    if (values) {
      try {
        const response = await confirmForgotPassword(
          userEmail,
          password.firstPassword,
          verificationCode
        );
        if (!response.data.error) setChangePasswordStatus(true);
      } catch (error) {
        console.log(error.response.data);
      }
    }
  };
  return (
    <>
      <FullHeightRow>
        <Layout className="authLayout" style={{ backgroundColor: "#ffffff" }}>
          <Row span={24}>
            <Col span={12} className="colLayoutBlock">
              <AuthLeftContainer>
                <div className="flexBlock" style={{ justifyContent: "center" }}>
                  <div className="vCenterBlock">
                    <div className="hCenterBox">
                      <AuthTitleBlock>
                        <div className="logo">
                          <img src={Logo} alt="HaberERP" />
                        </div>
                        <h1>Reset Password</h1>
                      </AuthTitleBlock>
                      {changePasswordStatus ? (
                        <div className="afterSuccess">
                          <AlertContainer
                          color="green"
                            icon={alertGreen}
                            msg={changePasswordMessage.success}
                          />

                          <Link to="/login" className="backToLoginBtn">
                            Go to Login Page
                          </Link>
                        </div>
                      ) : (
                        <HaberForm>
                          <>
                            <Form
                              name="basic"
                              autoComplete="off"
                              className="haberLogin haberSignup"
                              validateMessages={validateMessages}
                              onFinish={onFinish}
                            >
                              <Form.Item
                                name="useremail"
                                rules={[{ type: "email" }]}
                                className="mailIcon"
                                initialValue={userEmail}
                              >
                                <Input
                                  placeholder="Enter your email"
                                  disabled
                                />
                              </Form.Item>

                              <Form.Item
                                name="password"
                                rules={[{ required: true }]}
                                className="lockIcon firstPass"
                              >
                                <Input.Password
                                  placeholder="Enter your password"
                                  onChange={setFirst}
                                />
                              </Form.Item>

                              <Form.Item
                                name="confirmpassword"
                                rules={[{ required: true }]}
                                className="lockIcon"
                              >
                                <Input.Password
                                  placeholder="Confirm password"
                                  onChange={setSecond}
                                />
                              </Form.Item>

                              <ul className="pwdStrength">
                                <li>
                                  {validLength ? (
                                    <span>
                                      <img src={correctIcon} alt="correct" />
                                    </span>
                                  ) : (
                                    <span>
                                      <img src={wrongIcon} alt="wrong" />
                                    </span>
                                  )}{" "}
                                  Atleast 8 characters long
                                </li>
                                <li>
                                  {hasNumber ? (
                                    <span>
                                      <img src={correctIcon} alt="correct" />
                                    </span>
                                  ) : (
                                    <span>
                                      <img src={wrongIcon} alt="wrong" />
                                    </span>
                                  )}{" "}
                                  One numeric charater
                                </li>
                                <li>
                                  {upperCase ? (
                                    <span>
                                      <img src={correctIcon} alt="correct" />
                                    </span>
                                  ) : (
                                    <span>
                                      <img src={wrongIcon} alt="wrong" />
                                    </span>
                                  )}{" "}
                                  One uppercase character
                                </li>
                                <li>
                                  {lowerCase ? (
                                    <span>
                                      <img src={correctIcon} alt="correct" />
                                    </span>
                                  ) : (
                                    <span>
                                      <img src={wrongIcon} alt="wrong" />
                                    </span>
                                  )}{" "}
                                  One lowercase character
                                </li>
                                <li>
                                  {specialChar ? (
                                    <span>
                                      <img src={correctIcon} alt="correct" />
                                    </span>
                                  ) : (
                                    <span>
                                      <img src={wrongIcon} alt="wrong" />
                                    </span>
                                  )}{" "}
                                  One special character{" "}
                                </li>
                                <li>
                                  {match ? (
                                    <span>
                                      <img src={correctIcon} alt="correct" />
                                    </span>
                                  ) : (
                                    <span>
                                      <img src={wrongIcon} alt="wrong" />
                                    </span>
                                  )}{" "}
                                  Password matching
                                </li>
                              </ul>

                              <Form.Item>
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  className="btnSubmit"
                                  disabled={
                                    validLength &
                                    hasNumber &
                                    upperCase &
                                    lowerCase &
                                    match &
                                    specialChar
                                      ? false
                                      : true
                                  }
                                >
                                  {" "}
                                  Reset your password{" "}
                                </Button>
                              </Form.Item>
                            </Form>
                            <Link to="/login" className="backToLogin">
                              Go back to Login Page
                            </Link>
                          </>

                          <div className="pageLinks">
                            <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
                            <Link to="/terms-and-conditions">
                              Terms & Conditions
                            </Link>
                          </div>
                        </HaberForm>
                      )}
                    </div>
                  </div>
                </div>
              </AuthLeftContainer>
            </Col>
            <Col span={12} className="colLayoutBlock">
              <AuthRightContainer />
            </Col>
          </Row>
        </Layout>
      </FullHeightRow>
    </>
  );
};

export default ChangePassword;
